<!-- PrivatePromptsMain.vue -->
<template>

  <!-- Banner mit Hintergrundfarbe -->
  <v-container fluid class="banner">
    <v-row class="d-flex align-center justify-space-between">
      <!-- Text zentriert im Banner -->
      <v-col cols="12" md="11" class="d-flex justify-center text-center">
        <v-img src="./logo.png" alt="Private Prompts Logo" contain max-width="150"></v-img>
        <div>
          <h3>
            Deine Daten gehören dir!
          </h3>
          <h1 class="font-weight-bold">
            Private Prompts
          </h1>
          <h4>
            KI und Webdienste sicher nutzen
          </h4>
        </div>
      </v-col>
    </v-row>
  </v-container>

  <v-container fluid>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn color="secondary" text href="/">
          Startseite
        </v-btn>
        &nbsp;
        <v-btn color="secondary" text href="/impressum">
          Impressum
        </v-btn>
      </v-col>
    </v-row>
  </v-container>

  <v-container fluid class="status-message" style="padding-bottom: 8px;">
    <v-row justify="center">
      <v-col cols="12" md="10" class="text-left">
        <h3 id="Datenschutzerklarung">Datenschutzerklärung</h3>
        <p>Stand: Oktober 2026</p>

        <h4 id="1-Datenschutz-auf-einen-Blick">1. Datenschutz auf einen Blick</h4>
        <p><strong>Allgemeine Hinweise</strong></p>
        <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
          passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich
          identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter
          diesem Text aufgeführten Datenschutzerklärung.</p>
        <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
        <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie
          dem Abschnitt „Hinweis zur verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.</p>
        <p><strong>Wie erfassen wir Ihre Daten?</strong></p>
        <p>Diese Website enthält keine Formulare, kein Benutzerkonto und keinen Newsletter. Daten, die Sie uns aktiv
          mitteilen, erhalten wir nur, wenn Sie uns per E-Mail oder Telefon kontaktieren.</p>
        <p>Beim Besuch der Website werden automatisch technische Daten durch die IT-Systeme unseres Hosters erfasst
          (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Ihre IP-Adresse wird dabei
          ausschließlich vollständig anonymisiert gespeichert. Diese Website setzt keine Cookies und verwendet keine
          Tracking- oder Analysedienste von Drittanbietern.</p>
        <p><strong>Wofür nutzen wir Ihre Daten?</strong></p>
        <p>Die technischen Daten werden erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten und
          eine anonyme Zugriffsstatistik zu erstellen, mit der wir die Anzahl der Seitenaufrufe abschätzen können.</p>
        <p><strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong></p>
        <p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten
          personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten
          zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung
          jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die
          Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
        <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.</p>

        <h4 id="2-Hosting">2. Hosting</h4>
        <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
        <p><strong>All-Inkl</strong></p>
        <p>Anbieter ist die ALL-INKL.COM - Neue Medien Münnich, Inh. René Münnich, Hauptstraße 68, 02742 Friedersdorf
          (nachfolgend All-Inkl). Details entnehmen Sie der Datenschutzerklärung von All-Inkl:
          <a href="https://all-inkl.com/datenschutzinformationen/" target="_blank"
            rel="noopener">https://all-inkl.com/datenschutzinformationen/</a>.
        </p>
        <p>Die Verwendung von All-Inkl erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes
          Interesse an einer möglichst zuverlässigen Darstellung unserer Website.</p>
        <p><strong>Auftragsverarbeitung</strong></p>
        <p>Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen.
          Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser
          die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO
          verarbeitet.</p>

        <h4 id="3-Allgemeine-Hinweise-und-Pflichtinformationen">3. Allgemeine Hinweise und Pflichtinformationen</h4>
        <p><strong>Datenschutz</strong></p>
        <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
          personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung.</p>
        <p>Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie
          erläutert auch, wie und zu welchem Zweck das geschieht. Wir weisen darauf hin, dass die Datenübertragung im
          Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der
          Daten vor dem Zugriff durch Dritte ist nicht möglich.</p>
        <p><strong>Hinweis zur verantwortlichen Stelle</strong></p>
        <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
        <pre><code>Dr. Frank Börncke
Margaretenstraße 6b
82152 Krailling
Telefon: 089 97605480
E-Mail: frank.boerncke@gmail.com</code></pre>
        <p>Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über
          die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.)
          entscheidet.</p>
        <p><strong>Speicherdauer</strong></p>
        <p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre
          personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes
          Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
          gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen
          Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die
          Löschung nach Fortfall dieser Gründe.</p>
        <p><strong>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</strong></p>
        <p>Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf
          Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Sofern Sie in den Zugriff auf Informationen in Ihrem Endgerät eingewilligt haben, erfolgt die
          Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
          Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f
          DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen
          dieser Datenschutzerklärung informiert.</p>
        <p><strong>Empfänger von personenbezogenen Daten</strong></p>
        <p>Wir geben personenbezogene Daten nur dann an externe Stellen weiter, wenn wir gesetzlich hierzu verpflichtet
          sind, wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben, wenn Sie
          eingewilligt haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
          Auftragsverarbeitern geben wir personenbezogene Daten nur auf Grundlage eines gültigen Vertrags über
          Auftragsverarbeitung weiter.</p>
        <p><strong>Ihre Rechte</strong></p>
        <p>Da wir auf dieser Website nur sehr wenige personenbezogene Daten verarbeiten, sind die folgenden Rechte vor
          allem bei Anfragen per E-Mail oder Telefon relevant. Sie haben im Rahmen der geltenden gesetzlichen
          Bestimmungen jederzeit das Recht auf:</p>
        <ul>
          <li>unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger
            und den Zweck der Datenverarbeitung (Art. 15 DSGVO),</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO),</li>
          <li>Löschung Ihrer Daten (Art. 17 DSGVO),</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO),</li>
          <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO); die
            Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</li>
        </ul>
        <p>Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.</p>
        <div class="objection-notice">
          <p><strong>Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen (Art. 21 DSGVO)</strong></p>
          <p>Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, haben Sie jederzeit
            das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Verarbeitung Ihrer
            personenbezogenen Daten Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes
            Profiling. Die jeweilige Rechtsgrundlage, auf denen eine Verarbeitung beruht, entnehmen Sie dieser
            Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir Ihre betroffenen personenbezogenen Daten
            nicht mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung
            nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der
            Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen (Widerspruch nach Art. 21 Abs. 1 DSGVO).</p>
        </div>
        <p><strong>Beschwerderecht bei der zuständigen Aufsichtsbehörde</strong></p>
        <p>Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde,
          insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des
          mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
          gerichtlicher Rechtsbehelfe.</p>
        <p><strong>SSL- bzw. TLS-Verschlüsselung</strong></p>
        <p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung von Inhalten eine SSL- bzw.
          TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von
          „http://“ auf „https://“ wechselt, und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw.
          TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
          werden.</p>
        <p><strong>Widerspruch gegen Werbe-E-Mails</strong></p>
        <p>Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht
          ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der
          Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von
          Werbeinformationen, etwa durch Spam-E-Mails, vor.</p>

        <h4 id="4-Datenerfassung-auf-dieser-Website">4. Datenerfassung auf dieser Website</h4>
        <p><strong>Keine Cookies, kein lokaler Speicher</strong></p>
        <p>Diese Website setzt keine Cookies und speichert keine Informationen in Ihrem Browser (z. B. Local Storage).
          Schriftarten und Symbole werden lokal von unserem Server geladen; es findet beim Seitenaufruf keine Verbindung
          zu Servern Dritter statt. Eine Ausnahme bildet das Einführungsvideo, das erst nach Ihrem ausdrücklichen Klick
          geladen wird (siehe Abschnitt 5).</p>
        <p><strong>Server-Log-Dateien</strong></p>
        <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien,
          die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
        <ul>
          <li>Browsertyp und Browserversion</li>
          <li>verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>aufgerufene Seite bzw. Datei</li>
          <li>Uhrzeit der Serveranfrage</li>
          <li>vollständig anonymisierte IP-Adresse (die IP-Adresse wird als 0.0.0.0 gespeichert)</li>
        </ul>
        <p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Log-Dateien werden
          nach 7 Tagen automatisch gelöscht.</p>
        <p>Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat
          ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website –
          hierzu müssen die Server-Log-Files erfasst werden.</p>
        <p><strong>Zugriffsstatistik (Webalizer)</strong></p>
        <p>Aus den oben genannten Server-Log-Dateien erstellt unser Hoster mit der Software Webalizer eine
          Zugriffsstatistik (z. B. Anzahl der Seitenaufrufe pro Tag, aufgerufene Seiten, verwendete Browser). Wir
          nutzen diese Statistik, um abzuschätzen, wie häufig unsere Website besucht wird. Die Auswertung erfolgt
          ausschließlich auf dem Server unseres Hosters auf Basis der anonymisierten Log-Dateien; es werden keine
          Cookies gesetzt, keine Nutzerprofile erstellt und keine Daten an Dritte weitergegeben. Die Statistik ist
          passwortgeschützt und nicht öffentlich einsehbar.</p>
        <p>Die Auswertung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an
          der anonymisierten Analyse der Nutzung unserer Website, um unser Angebot zu verbessern.</p>

        <p><strong>Anfrage per E-Mail oder Telefon</strong></p>
        <p>Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden
          personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und
          verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
        <p>Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit
          der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist.
          In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven
          Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6
          Abs. 1 lit. a DSGVO), sofern diese abgefragt wurde.</p>
        <p>Die von Ihnen an uns per Kontaktanfrage übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
          auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt
          (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere
          gesetzliche Aufbewahrungsfristen – bleiben unberührt.</p>

        <h4 id="5-Plugins-und-Tools">5. Plugins und Tools</h4>
        <p><strong>Einführungsvideo von HeyGen</strong></p>
        <p>Auf unserer Startseite bieten wir ein Einführungsvideo an, das vom Anbieter HeyGen (HeyGen Technology Inc.,
          12130 Millennium Drive, Suite 300, Los Angeles, CA 90094, USA) bereitgestellt wird. Das Video wird über eine Zwei-Klick-Lösung eingebunden: Beim Öffnen des
          Video-Fensters wird zunächst keine Verbindung zu HeyGen hergestellt. Erst wenn Sie ausdrücklich auf
          „Video laden“ klicken, wird das Video von den Servern von HeyGen geladen.</p>
        <p>Dabei wird Ihre IP-Adresse an HeyGen übermittelt. Zudem kann HeyGen Cookies oder vergleichbare Technologien
          auf Ihrem Endgerät einsetzen und weitere Informationen über Ihren Browser erheben. Auf diese Verarbeitung
          haben wir keinen Einfluss.</p>
        <p>Die Daten können in die USA übertragen werden. Das Unternehmen verfügt über eine Zertifizierung nach dem
          „EU-US Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen zwischen der Europäischen Union und den
          USA, der die Einhaltung europäischer Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten
          soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten.
        </p>
        <p>Die Nutzung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG), die Sie durch den Klick auf „Video laden“
          erteilen. Ihre Einwilligung wird nicht gespeichert und gilt nur für den aktuellen Seitenaufruf. Sie können sie
          jederzeit widerrufen, indem Sie das Video-Fenster schließen bzw. die Seite neu laden. Weitere Informationen
          finden Sie in der Datenschutzerklärung von HeyGen:
          <a href="https://www.heygen.com/privacy" target="_blank" rel="noopener">https://www.heygen.com/privacy</a>.
        </p>
        <p><strong>Downloads und Quellcode auf GitHub</strong></p>
        <p>Die Installationsdateien von <span class="brand-name">Private Prompts</span> sowie der Quellcode werden auf
          der Plattform GitHub bereitgestellt. Anbieter ist die GitHub, Inc., 88 Colin P. Kelly Jr. St., San
          Francisco, CA 94107, USA. Wir binden GitHub nicht in unsere Website ein, sondern verlinken lediglich dorthin.
          Erst wenn Sie einen Download- oder GitHub-Link anklicken, verlassen Sie unsere Website und Ihr Browser baut
          eine Verbindung zu GitHub auf. Für die dortige Datenverarbeitung ist GitHub verantwortlich. Weitere
          Informationen finden Sie in der Datenschutzerklärung von GitHub:
          <a href="https://docs.github.com/de/site-policy/privacy-policies/github-general-privacy-statement"
            target="_blank"
            rel="noopener">https://docs.github.com/de/site-policy/privacy-policies/github-general-privacy-statement</a>.
        </p>
        <p><strong>Links zu anderen Websites</strong></p>
        <p>Unsere Website enthält Links zu externen Websites (z. B. Presseartikel oder soziale Netzwerke). Beim
          Anklicken eines solchen Links verlassen Sie unsere Website. Für die Datenverarbeitung auf diesen Websites ist
          der jeweilige Betreiber verantwortlich.</p>

        <h4 id="6-Quelle">6. Quelle</h4>
        <p>Diese Datenschutzerklärung basiert in Teilen auf Vorlagen von
          <a href="https://www.e-recht24.de" target="_blank" rel="noopener">https://www.e-recht24.de</a> und wurde an
          die tatsächliche Datenverarbeitung auf dieser Website angepasst.
        </p>

      </v-col>
    </v-row>

  </v-container>



  <!-- Logo Section -->
  <v-container class="funding" fluid>
    <p>
      Die Entwicklung von <span class="brand-name">Private Prompts</span> wurde
      im Zeitraum 1.9.2024-28.02.2025 gefördert durch das <strong>Bundesministerium
        für Bildung und Forschung</strong> und den <strong>Prototype Fund</strong> (Förderkennzeichen 01IS24S44).
    </p>
    <v-row justify="center" class="ml-9 mr-7">
      <v-col cols="12" md="4" class="d-flex justify-center align-center">
        <v-img src="./logos/bmbf_de.jpg" alt="BMBF Logo" contain max-width="30vw" max-height="30vw"></v-img>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center align-center">
        <v-img src="./logos/PrototypeFund_Logo_smallest.svg" alt="Prototype Fund Logo" contain max-width="30vw"
          max-height="30vw"></v-img>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center align-center">
        <v-img src="./logos/logo-okfn.svg" alt="Open Knowledge Foundation Logo" contain max-width="30vw"
          max-height="30vw"></v-img>
      </v-col>
    </v-row>
    <br />
    <p>
      Die Weiterentwicklung von <span class="brand-name">Private Prompts</span> erfolgt derzeit als privates Projekt.
    </p>
  </v-container>

  <!-- Footer mit rechtlichen Informationen -->
  <v-footer class="footer-banner">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="text-center">
          <p>&copy; 2025 Frank Börncke, Private Prompts</p>
          <v-btn color="secondary" text href="/">
            Startseite
          </v-btn>
          &nbsp;
          <v-btn color="secondary" text href="/impressum">
            Impressum
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>

</template>

<script>
export default {
  name: 'PrivacyStatementPage',
};
</script>

<style scoped>
/* Schriftarten */
body {
  font-family: 'Open Sans', sans-serif;
}

/* Responsive Schriftgrößen */
h1 {
  font-size: clamp(2.5rem, 5vw, 4rem);
}

h2 {
  font-size: clamp(2rem, 4vw, 3rem);
}

h3 {
  font-size: clamp(1.75rem, 3vw, 2.5rem);
}

/* Abschnittsüberschriften der Datenschutzerklärung (größer als fette Absatz-Überschriften) */
.status-message h4 {
  font-size: 1.5rem;
  margin-top: 1.5em;
  margin-bottom: 0.75em;
}

p,
li {
  font-size: 1.125rem;
  line-height: 1.5;
  margin-bottom: 1.5em;
  /* Erhöhter Abstand zwischen Absätzen */
}

/* Hervorgehobener Hinweis auf das Widerspruchsrecht (Art. 21 Abs. 4 DSGVO) */
.objection-notice {
  border: 2px solid var(--secondary-color);
  border-radius: 10px;
  padding: 16px 16px 0;
  margin-bottom: 1.5em;
}

/* Begrenzung der Textbreite */
.text-content {
  max-width: 800px;
  margin: 0 auto;
}

/* Markierung von "Private Prompts" */
.brand-name {
  font-weight: bold;
  color: var(--accent-color);
}


/* Hintergrundbild mit Overlay */
.v-img {
  position: relative;
  transition: transform 0.3s ease;
}

.v-img>.v-container {
  position: relative;
  z-index: 1;
}

/* Buttons */
.v-btn {
  border-radius: 10px;
  height: 50px;
  transition: all 0.3s ease;
  background-color: var(--button-color);
  text-transform: none;
  /* This prevents text from being converted to uppercase */
}

.v-btn:hover {
  background-color: var(--secondary-color) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

/* Icons */
.v-icon {
  color: var(--primary-color);
}

.v-icon:hover {
  color: var(--secondary-color);
  cursor: pointer;
}

/* Textfarben */
.body {
  background-color: var(--background-color);
  color: var(--text-color);
}

body,
p,
li {
  color: var(--text-color);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--secondary-color);
  font-family: 'Montserrat', sans-serif;
}

/* Abschnitte */
.status-message,
.teaser-image-section,
.quickstart,
.how-it-works,
.benefits,
.use-cases,
.feedback,
.frequently-asked-questions,
.press-review,
.about-me,
.funding {
  padding: 50px 15px;
}


.status-message {
  background-color: #F1F1F1;
}

.teaser-image-section {
  background-color: #EAEAEA;
}

.quickstart {
  background-color: #F1F1F1;
}

.how-it-works {
  background-color: #EAEAEA;
}

.benefits {
  background-color: #F1F1F1;
}

.use-cases {
  background-color: #EAEAEA;
}

.feedback {
  background-color: #F1F1F1;
}

.frequently-asked-questions {
  background-color: #EAEAEA;
}

.press-review {
  background-color: #F1F1F1;
}

.about-me {
  background-color: #EAEAEA;
}

.funding {
  background-color: #F1F1F1;
}



/* Karten und Bilder */
.v-card {
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.v-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.v-card-title {
  font-weight: bold;
  color: var(--secondary-color);
}

.v-card-text {
  color: var(--text-color);
  flex-grow: 1;
}

.v-col.d-flex {
  display: flex;
}

.v-img:hover {
  transform: none;
}

/* Social Links */
.social-links {
  padding-bottom: 0px;
}

.social-links .v-btn {
  margin: 0 10px;
}

.social-links .v-icon {
  color: var(--text-color);
}

/* Footer */
.v-footer {
  background-color: var(--secondary-color) !important;
}

.v-footer .white--text {
  color: #ffffff !important;
}

/* Video-Bereich Anpassungen */
.video-card {
  position: relative;
}

.video-banner {
  position: absolute;
  top: 30px;
  right: -100px;
  background-color: rgba(255, 111, 97, 0.9);
  /* Akzentfarbe mit Transparenz */
  color: white;
  padding-left: 100px;
  padding-right: 100px;
  transform: rotate(45deg);
  font-weight: bold;
  z-index: 2;
}

.video-card .v-img {
  position: relative;
}

.video-card .v-img .v-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-card .v-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video-card .v-icon {
  font-size: 64px;
}


/* Banner-Stil */
.banner {
  background: linear-gradient(60deg, #3aad9f, #466673);
  padding: 60px 15px;
}

.banner h1 {
  font-size: 3rem;
  color: #092925;
}

.banner h2 {
  font-size: 1.5rem;
  color: #264653;
  margin-bottom: 10px;
}

.banner h3 {
  font-size: 1.4rem;
  color: #264653;
  margin-bottom: 0px;
}

.banner h4 {
  font-size: 1.25rem;
  color: #264653;
  margin-bottom: 10px;
}

.footer-banner {
  background: linear-gradient(60deg, #3aad9f, #466673);
}

/* Carousel Image and Caption */
.carousel-image {
  object-fit: contain;
  width: 80%;
  height: auto;
  margin: 0 auto;
  display: block;
}

.caption {
  position: relative;
  background: #41A693;
  /* Semi-transparent background */
  color: #0A2621;
  padding: 16px;
  border-radius: 5px;
  font-weight: 500;
  margin-bottom: 15px;
}

.caption strong {
  color: var(--accent-color);
}

/* Carousel Item Adjustments */
.v-carousel-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
}

.faq-title {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 0.5rem;
}

.faq-answer {
  font-size: 1.125rem !important;
  /* make font italic */
  font-style: italic;
  line-height: 1.5;
  color: var(--text-color);
}

.no-hover:hover {
  background: none !important;
  box-shadow: none !important;
  width: 40px;
  color: green;
  height: 40px;
}

/* Responsive Design for Mobile */
@media (max-width: 600px) {
  .caption {
    font-size: 1rem;
    padding: 5px;
  }
}

@media (max-width: 600px) {
  .banner {
    padding: 40px 15px;
  }
}

@media (min-width: 600px) {

  .how-it-works .v-col,
  .funding .v-col,
  .benefits .v-col {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
